// src/oidc-client.ts
import { UserManager, WebStorageStateStore } from "oidc-client-ts";

export const userManager = new UserManager({
  authority: "https://auth-dev.nartio.com",
  client_id: "spa-web-application",
  redirect_uri: "https://sample-spa-dev.nartio.com/callback",
  post_logout_redirect_uri: "https://sample-spa-dev.nartio.com/",
  response_type: "code",
  scope: "openid offline_access roles backend_api.all email",
  userStore: new WebStorageStateStore({ store: window.sessionStorage })
});
